import { getMessage } from '../../helpers/miscHelper';

const SecurityStatement = (props) => {
  const { settings } = props;
  return (
    <div
      className="c7-message c7-message--login-security"
      dangerouslySetInnerHTML={{
        __html: getMessage('Security Statement', settings)
      }}
    />
  );
};

export default SecurityStatement;
